module.exports = __webpack_public_path__ + "img/zm_images@3x.2b64a804.png";